import { createFileRoute } from '@tanstack/react-router'
import { PageShell } from '@/features/public-site/page-shell'
import { SimpleHero, HeroBadges, PricingCta, Panel, Pill } from '@/features/public-site/sections'

export const Route = createFileRoute('/ai-video-editor')({
  component: AiVideoEditorPage,
})

function AiVideoEditorPage() {
  return (
    <PageShell>
      <SimpleHero
        eyebrow="专业时间线编辑"
        title="AI 生成初稿，"
        highlighted="时间线精修成片"
        description="AI 帮你生成草稿，你在专业时间线里逐轨调整素材、字幕、音频和效果，控制每一帧。"
        buttonLabel="免费开始"
      />

      <HeroBadges
        items={[
          '多轨时间线',
          '逐帧精修',
          '字幕样式',
          '音频混音',
          '一键导出',
        ]}
      />

      {/* Split section */}
      <section className="mx-auto mt-16 grid max-w-4xl gap-8 px-4 sm:px-6 lg:grid-cols-2">
        {/* Editor preview */}
        <div className="overflow-hidden rounded-2xl border border-border bg-card">
          <div className="flex aspect-video items-center justify-center bg-muted">
            <div className="text-center">
              <div className="mx-auto flex size-16 items-center justify-center rounded-full bg-accent">
                <span className="text-2xl">▶</span>
              </div>
              <p className="mt-3 text-xs text-muted-foreground">编辑器预览</p>
            </div>
          </div>
        </div>

        <Panel>
          <h2 className="text-xl font-bold text-foreground">
            每一帧都可以掌控
          </h2>
          <p className="mt-3 text-sm text-muted-foreground">
            AI 负责生成初稿--你在 JIAN 时间线里做最终精修。
          </p>
          <div className="mt-6 space-y-3">
            {[
              '审核并调整 AI 生成的片段',
              '手动调整字幕、时间轴和样式',
              '拖拽即可裁剪和重新排列',
              '导出为视频文件或生成分享链接',
            ].map((item) => (
              <div key={item} className="flex gap-3">
                <Pill>✓</Pill>
                <span className="text-sm text-muted-foreground">{item}</span>
              </div>
            ))}
          </div>
        </Panel>
      </section>

      <PricingCta />
    </PageShell>
  )
}
